import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { get,set } from ".";
import { IdentityInfo } from "../../model/identity-info.model";

const MAX_RETRY_ATTEMPTS = 200;

@Injectable({ providedIn: 'root' })
export class AuthService {
    token: string;
    private azureTokenPromise: Promise<void> | null = null;
    private azureRefreshTimer: ReturnType<typeof setTimeout> | null = null;
    private azureFailureCount = 0;

    constructor(
        private httpClient: HttpClient //
    ) { }

    loadIdentityInfo(): Promise<void> {
        return new Promise((resolve) => {
            this.httpClient.get<IdentityInfo>(`${get('hunchAppUrl')}/api/v2/identity-connect/info`, { withCredentials: true })
                .subscribe({
                    next: (resp: IdentityInfo) => {
                        this.token = resp.token;
                        set('user', resp.user);
                        set('accounts', resp.accounts);
                        set('token', resp.token);
                        resolve();
                    },
                    error: (err: any) => {
                        console.error(err);
                        window.location.assign(get('hunchAppUrl'));
                        resolve();
                    }
                })
        })
    };

    loadAzureToken(): Promise<void> {
        if (this.azureTokenPromise) return this.azureTokenPromise;

        this.azureTokenPromise = new Promise<void>((resolve) => {
            this.httpClient.get<any>(`${get('hunchAppUrl')}/api/v1/authorizations/azuread/token?scope=meta`, { withCredentials: true })
                .subscribe({
                    next: (resp: any) => {
                        set('azureToken', resp.accessToken);
                        this.azureFailureCount = 0;
                        this.scheduleAzureRefresh(resp.expiresIn * 1000);
                        this.azureTokenPromise = null;
                        resolve();
                    },
                    error: (err: any) => {
                        console.error(err);
                        this.azureFailureCount++;
                        if (this.azureFailureCount < MAX_RETRY_ATTEMPTS) {
                            this.scheduleAzureRefresh(10000);
                        } else {
                            console.warn(`loadAzureToken: giving up after ${MAX_RETRY_ATTEMPTS} failed attempts`);
                        }
                        this.azureTokenPromise = null;
                        resolve();
                    }
                })
        });

        return this.azureTokenPromise;
    };

    private scheduleAzureRefresh(delayMs: number): void {
        if (this.azureRefreshTimer) {
            clearTimeout(this.azureRefreshTimer);
            this.azureRefreshTimer = null;
        }
        if (delayMs <= 0) return;
        this.azureRefreshTimer = setTimeout(() => {
            this.azureRefreshTimer = null;
            this.loadAzureToken();
        }, delayMs);
    }
}